// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardGrid {
  display: grid;
  grid-template-columns: 250px 250px 250px 250px 250px;
  grid-template-rows: 250px 250px 250px 250px; }
  @media only screen and (max-height: 1000px) {
    .CardGrid {
      grid-template-columns: 220px 220px 220px 220px 220px;
      grid-template-rows: 220px 220px 220px 220px; } }
  @media only screen and (max-height: 800px) {
    .CardGrid {
      grid-template-columns: 25vh 25vh 25vh 25vh 25vh;
      grid-template-rows: 25vh 25vh 25vh 25vh; } }
  @media only screen and (max-width: 1300px) {
    .CardGrid {
      grid-template-columns: 16vw 16vw 16vw 16vw 16vw;
      grid-template-rows: 16vw 16vw 16vw 16vw; } }
`, "",{"version":3,"sources":["webpack://./src/components/CardGrid.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oDAAoD;EACpD,2CAA2C,EAAA;EAE3C;IALF;MAMI,oDAAoD;MACpD,2CAA2C,EAAA,EAY9C;EATC;IAVF;MAWI,+CAA+C;MAC/C,uCAAuC,EAAA,EAO1C;EAJC;IAfF;MAgBI,+CAA+C;MAC/C,uCAAuC,EAAA,EAE1C","sourcesContent":[".CardGrid {\n  display: grid;\n  grid-template-columns: 250px 250px 250px 250px 250px;\n  grid-template-rows: 250px 250px 250px 250px;\n\n  @media only screen and (max-height: 1000px) {\n    grid-template-columns: 220px 220px 220px 220px 220px;\n    grid-template-rows: 220px 220px 220px 220px;\n  }\n\n  @media only screen and (max-height: 800px) {\n    grid-template-columns: 25vh 25vh 25vh 25vh 25vh;\n    grid-template-rows: 25vh 25vh 25vh 25vh;\n  }\n\n  @media only screen and (max-width: 1300px) {\n    grid-template-columns: 16vw 16vw 16vw 16vw 16vw;\n    grid-template-rows: 16vw 16vw 16vw 16vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
